import { useAutoneTranslation } from '@autone/translations';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../atoms';
import { useAdvancedFiltersContext } from '../AdvancedFilters.context';

interface AdvancedFiltersConditionCombineModeProps {
  rowIdx: number;
}

export const AdvancedFiltersConditionCombineMode = ({
  rowIdx,
}: AdvancedFiltersConditionCombineModeProps) => {
  const { common } = useAutoneTranslation();
  const { state, dispatch } = useAdvancedFiltersContext();
  const { conditionCombineMode } = state;

  if (rowIdx === 0) {
    return (
      <p className="italic border h-12 flex items-center px-4 rounded-l-sm">
        {common('advanced-filters.where')}
      </p>
    );
  } else if (rowIdx === 1) {
    return (
      <Select
        value={conditionCombineMode}
        onValueChange={(val: 'and' | 'or') =>
          dispatch({ type: 'CHANGE_COMBINE_MODE', payload: { condition: val } })
        }
      >
        <SelectTrigger
          id="advanced-filter-condition"
          aria-label="Advanced filter condition"
          className="rounded-r-none"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="and">{common('advanced-filters.and')}</SelectItem>
          <SelectItem value="or">{common('advanced-filters.or')}</SelectItem>
        </SelectContent>
      </Select>
    );
  } else {
    return (
      <div className="px-3 h-12 border flex items-center text-sm">
        {conditionCombineMode === 'and'
          ? common('advanced-filters.and')
          : common('advanced-filters.or')}
      </div>
    );
  }
};
